import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb1000',
    ecrans: ['00-2'],
    params:['?pvecleint','?prucleint']
});